import { createModuleI18n } from '@/shared/i18n/create-module-i18n'

/** 项目模块 i18n：`project.{section?}.{key}` */
export function useProjectI18n(section?: string) {
  return createModuleI18n('project', section)
}
